(function(){
'use strict';

function scModalGroupContent() {
  return {
    restrict: 'A',
    // eslint-disable-next-line no-unused-vars
    link: function link(scope, element) {
      element.hide();
    }
  };
}

angular.module('classy').directive('scModalGroupContent', scModalGroupContent);
})();